import baseUrl from "../lightingApiHost";
import { callApi } from "./util";

const getEnabledLightingFeatures = () => {
  return callApi(`${baseUrl}configuration/features`);
};

export default {
  getEnabledLightingFeatures
};
